import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'className': 'ui-popup ui-popup--tiny' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Create a New Feature Inclusion Preset')), React.createElement('div', { 'className': 'ui-popup-body' }, React.createElement('input', {
        'className': 'generic-popup-textbox',
        'placeholder': 'Enter Preset Name',
        'value': this.state.name,
        'onChange': this.setName
    }), React.createElement('textarea', {
        'className': 'generic-popup-textarea',
        'placeholder': 'Enter Preset Description',
        'value': this.state.description,
        'onChange': this.setDescription
    })), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': this.props.hideAddNewPresetPopup
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': this.doSave
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Save'))));
}